var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPfLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 52,
    viewBox: "0 0 63 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9453 0H7.94531L15.9453 10H39.9453L45.9453 0Z",
    fill: "#47127D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9453 2L43.4453 12L49.9453 21L41.9453 32H26.4453L11.9453 52H24.9453L31.9453 42H47.9453L62.4453 21L48.9453 2Z",
    fill: "#47127D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5289 16L0 42H12.0289L23.0289 26H38.5289L42.0289 21L38.5289 16H18.5289Z",
    fill: "#7BA340"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfLogo);
export default __webpack_public_path__ + "static/media/PF_Logo.3c2935fa0430d4eeefeadbdec69014c6.svg";
export { ForwardRef as ReactComponent };